module.exports = __webpack_public_path__ + "static/media/faq.2d09f7a1.WebP";